<template>
  <div
    class="obituary-threaded-comments__delete edit-obituary-comment__delete-content"
  >
    <p v-text="texts.threadedComments.areYouSureDelete" />

    <div class="edit-obituary-comment__button-group">
      <button
        class="btn danger"
        type="button"
        @click.prevent="deleteAction"
        v-text="texts.common.delete"
      />

      <button
        class="btn link"
        type="button"
        @click.prevent="cancelAction"
        v-text="texts.common.cancel"
      />
    </div>
  </div>
</template>

<script>
  import { useIsMobile } from "Main/composables/useIsMobile";
  import { mapActions, mapMutations, mapState } from "vuex";

  export default {
    computed: {
      ...mapState("threadedComments", [
        "parent",
        "deleteComment",
        "deleteCommentHash",
        "modalContext",
      ]),

      parentHasChildren() {
        return !!this.parent.children?.length;
      },

      parentId() {
        return this.parent.id;
      },
    },

    data() {
      return {
        texts: lavendlaObituary,
      };
    },

    methods: {
      ...mapMutations("threadedComments", ["setModalContext"]),
      ...mapActions({
        delete: "comments/deleteObituaryComment",
        toggleModal: "threadedComments/toggleModal",
      }),

      cancelAction() {
        if (this.parentHasChildren) {
          return this.setModalContext("list");
        }

        return this.toggleModal();
      },

      deleteAction() {
        const data = {
          hash: this.deleteCommentHash,
          id: this.deleteComment.id,
          parentId: this.parentId,
        };

        this.delete(data)
          .then(() => {
            this.cancelAction();
          })
          .catch((error) => {
            if (error.serverMessage) {
              // biome-ignore lint/suspicious/noAlert: no in-page error UI exists for this form yet
              alert(error.serverMessage);
            } else {
              // biome-ignore lint/suspicious/noAlert: no in-page error UI exists for this form yet
              alert(this.texts.threadedComments.deleteError);
            }
          });
      },
    },
    name: "ThreadedCommentsDelete",

    setup() {
      const { isMobile, isTablet } = useIsMobile();
      return { isMobile, isTablet };
    },
  };
</script>
